import { DoubleArrow } from '@mui/icons-material'
import { IconButton } from '@mui/material'
import { useTranslation } from 'react-i18next'
import Header from '../../../../shared/components/Header'
import TypeFilter from '../../../../shared/components/TypeFilter'
import HiddenDesktop from '../../../../shared/styles/HiddenDesktop'
import ScrollSubheader from '../../../../shared/styles/ScrollSubHeader'
import SubHeader from '../../../../shared/styles/Subheader'

interface HeaderSectionProps {
  filters: any
  coursetypes: { id: number; name: string }[]
  handleChangeFilter: (id?: number | string, category_id?: number | null) => void
}

const HeaderSection = ({ filters, coursetypes, handleChangeFilter }: HeaderSectionProps) => {
  const { t } = useTranslation(['global'])
  const myElement: HTMLElement | null = document.getElementById('windowCourseAdmin')
  let midOfWidth = window.innerWidth / 2

  return (
    <>
      <Header title={t('academy')} />
      <SubHeader>
        <ScrollSubheader id="windowCourseAdmin">
          <TypeFilter
            id={0}
            type={t('all')}
            categories={[]}
            active={filters.coursetype_id === null}
            handleChangeFilter={handleChangeFilter}
          />
          {coursetypes.map((coursetype: any) => (
            <TypeFilter
              key={coursetype.id}
              id={coursetype.id}
              type={coursetype.name}
              categories={[]}
              active={coursetype.id === filters.coursetype_id}
              handleChangeFilter={handleChangeFilter}
            />
          ))}
        </ScrollSubheader>
        <HiddenDesktop>
          <IconButton
            sx={{ position: 'absolute !important', right: 0, top:'17%', zIndex: 10, backgroundColor: 'white' }}
            className="buttonScroll"
            onClick={() => {
              myElement?.scrollBy(midOfWidth, 0)
            }}
          >
            <DoubleArrow />
          </IconButton>
        </HiddenDesktop>
      </SubHeader>
    </>
  )
}

export default HeaderSection
